import { makeStyles } from '@material-ui/core/styles';

// Share the existing settings surfaces and spacing across ordinary and scheduled lighting.
export default makeStyles((theme) => ({
  root: {
    margin: '24px',
    minWidth: 0,
    '& > .MuiAlert-root': { marginBottom: 12 },
    [theme.breakpoints.down('xs')]: { margin: '12px 4px' }
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: 12,
    marginBottom: 8
  },
  heading: { display: 'flex', alignItems: 'center', gap: 8 },
  meta: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: '8px 24px',
    marginBottom: 16
  },
  card: {
    padding: '24px',
    marginBottom: 16,
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.innerContainer?.background ?? theme.palette.background.paper,
    boxShadow: theme.palette.innerContainer?.shadow
      ? `0 3px 2px ${theme.palette.innerContainer.shadow}`
      : theme.shadows[1],
    [theme.breakpoints.down('xs')]: { padding: '16px 12px' }
  },
  accordion: {
    backgroundColor: theme.palette.outerContainer?.background ?? theme.palette.background.paper,
    boxShadow: 'none',
    border: `1px solid ${theme.palette.divider}`,
    marginBottom: 8,
    '&:before': { display: 'none' },
    '&.Mui-expanded': { margin: '8px 0' }
  },
  details: {
    display: 'block',
    minWidth: 0,
    padding: '8px 24px 20px',
    [theme.breakpoints.down('xs')]: { padding: '8px 12px 16px' }
  },
  fields: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: '16px 24px',
    '& > .MuiTextField-root': { flex: '1 1 220px', minWidth: 0, maxWidth: 420 }
  },
  copy: {
    display: 'grid',
    gridTemplateColumns: 'minmax(0, 1fr) minmax(0, 1fr) auto',
    gap: 16,
    alignItems: 'center',
    marginTop: 24,
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: 'minmax(0, 1fr)',
      '& > button': { justifySelf: 'start' }
    }
  },
  point: {
    display: 'grid',
    gridTemplateColumns: 'auto minmax(0, 1fr) minmax(220px, 1.5fr) repeat(2, minmax(0, 1fr)) auto',
    gap: 16,
    alignItems: 'center',
    padding: '12px 8px',
    border: '2px solid transparent',
    borderBottom: `1px solid ${theme.palette.divider}`,
    [theme.breakpoints.down('md')]: { gridTemplateColumns: 'repeat(2, minmax(0, 1fr))' },
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: 'minmax(0, 1fr)',
      gap: 12,
      '& > .MuiTextField-root': { minWidth: 0 }
    }
  },
  pointList: {
    maxHeight: 240,
    overflowY: 'auto',
    marginTop: 12,
    border: `1px solid ${theme.palette.divider}`
  },
  selectedPoint: { borderColor: theme.palette.secondary.main },
  actions: { display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 8, marginTop: 16 },
  slider: { maxWidth: 640, margin: '8px 12px 0', width: 'calc(100% - 24px)' }
}));
